import { render, staticRenderFns } from "./showUpdata.vue?vue&type=template&id=19a209f6&scoped=true"
import script from "./showUpdata.vue?vue&type=script&lang=js"
export * from "./showUpdata.vue?vue&type=script&lang=js"
import style0 from "./showUpdata.vue?vue&type=style&index=0&id=19a209f6&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a209f6",
  null
  
)

export default component.exports